import image1 from './1-10.png';
import image2 from './11-20.png';
import image3 from './21-30.png';

export default [image1, image2, image3];
